// Copyright 2022-2023 @Polkasafe/polkaSafe-ui authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

export const styledTheme = {
	colors: {
		bg_main: '#1B2028',
		bg_secondary: '#24272E',
		failure: '#E63946',
		highlight: '#1A2A42',
		primary: '#1573FE',
		success: '#06D6A0',
		text_main: '#FFFFFF',
		text_secondary: '#8B8B8B',
		waiting: '#FF9F1C'
	},
	fonts: {
		font_default: 'Archivo, sans-serif'
	}
};